/**
 * 触摸优化工具
 * 针对 iPad 和移动设备的触摸优化
 */
export class TouchOptimizer {
  static initialized = false;
  
  /**
   * 初始化所有触摸优化
   */
  static init() {
    if (this.initialized) return;
    
    this.preventDoubleTapZoom();
    this.preventTextSelection();
    this.addTouchFeedback();
    this.optimizeTouchResponse();
    
    this.initialized = true;
  }
  
  /**
   * 防止双击缩放
   */
  static preventDoubleTapZoom() {
    let lastTouchEnd = 0;
    
    document.addEventListener('touchend', (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    }, { passive: false });
  }
  
  /**
   * 禁用文本选择（游戏区域）
   */
  static preventTextSelection() {
    const style = document.createElement('style');
    style.textContent = `
      .game-container, .game-container * {
        -webkit-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
      }
    `;
    document.head.appendChild(style);
  }
  
  /**
   * 添加触摸反馈
   */
  static addTouchFeedback() {
    document.addEventListener('touchstart', (e) => {
      const target = e.target.closest('[data-touch-feedback]');
      if (target) {
        target.style.transform = 'scale(0.95)';
        target.style.transition = 'transform 0.1s';
      }
    }, { passive: true });
    
    document.addEventListener('touchend', (e) => {
      const target = e.target.closest('[data-touch-feedback]');
      if (target) {
        target.style.transform = '';
      }
    }, { passive: true });
  }
  
  /**
   * 优化触摸响应
   * 减少触摸延迟
   */
  static optimizeTouchResponse() {
    // 设置 viewport 禁止缩放已经处理了大部分延迟问题
    // 这里可以添加其他优化
  }
  
  /**
   * 为元素添加触摸和鼠标事件统一处理
   * @param {HTMLElement} element
   * @param {Function} callback
   */
  static setupTouch(element, callback) {
    let touchStarted = false;
    
    element.addEventListener('touchstart', (e) => {
      touchStarted = true;
      e.preventDefault();
      callback(e);
    }, { passive: false });
    
    element.addEventListener('mousedown', (e) => {
      if (!touchStarted) {
        callback(e);
      }
      touchStarted = false;
    });
  }
  
  /**
   * 震动反馈（如果支持）
   * @param {number|number[]} pattern
   */
  static vibrate(pattern = 50) {
    if (navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  }
  
  /**
   * 检测设备类型
   * @returns {object}
   */
  static detectDevice() {
    const ua = navigator.userAgent;
    return {
      isIPad: /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
      isIPhone: /iPhone/.test(ua),
      isIOS: /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
      isAndroid: /Android/.test(ua),
      isMobile: /Mobile|Android|iPhone|iPad/.test(ua),
      isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0
    };
  }
}
